/**
 * Player Skills Development Categories Configuration
 * 
 * This file defines the color scheme and structure for the four main skill categories
 * used throughout the application for player assessments and reports.
 * 
 * Color Scheme:
 * - Technical: Red (#ef4444)
 * - Physical: Yellow (#eab308)
 * - Psychological: Green (#10b981)
 * - Social: Blue (#3b82f6)
 */

export const SKILLS_CATEGORIES = {
  technical: {
    title: 'Technical',
    color: '#ef4444',
    colorRgba: 'rgba(239, 68, 68, 0.8)',
    icon: 'T',
    badgeBackground: '#fee2e2',
    badgeColor: '#991b1b',
  },
  physical: {
    title: 'Physical',
    color: '#eab308',
    colorRgba: 'rgba(234, 179, 8, 0.8)',
    icon: 'P',
    badgeBackground: '#fef9c3',
    badgeColor: '#854d0e',
  },
  psychological: {
    title: 'Psychological',
    color: '#10b981',
    colorRgba: 'rgba(16, 185, 129, 0.8)',
    icon: 'M',
    badgeBackground: '#d1fae5',
    badgeColor: '#065f46',
  },
  social: {
    title: 'Social',
    color: '#3b82f6',
    colorRgba: 'rgba(59, 130, 246, 0.8)',
    icon: 'S',
    badgeBackground: '#dbeafe',
    badgeColor: '#1e40af',
  },
} as const;

export type SkillCategory = keyof typeof SKILLS_CATEGORIES;

// Default colors array for charts (in category order)
export const CHART_COLORS = [
  SKILLS_CATEGORIES.technical.color,
  SKILLS_CATEGORIES.physical.color,
  SKILLS_CATEGORIES.psychological.color,
  SKILLS_CATEGORIES.social.color,
  '#ea580c', // Additional colors if needed
  '#0891b2',
];

// Helper function to get category color
export const getCategoryColor = (category: SkillCategory): string => {
  return SKILLS_CATEGORIES[category]?.color || '#64748b';
};

// Helper function to get category title
export const getCategoryTitle = (category: SkillCategory): string => {
  return SKILLS_CATEGORIES[category]?.title || category;
};
